import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SessionKey } from "@shared/clickar-constants";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-private-contact",
	templateUrl: "./private-contact.component.html",
	styleUrl: "./private-contact.component.scss",
	standalone: false
})
export class PrivateContactComponent implements OnInit {
	localizedCountry: any;

	constructor(
		public wcmService: WcmService,
		private storageService: StorageManagerService,
		public translate: TranslateService
	) { }

	ngOnInit() {
		this.localizedCountry = this.storageService.getSessionItem(
			SessionKey.GEOLOCATION_MARKET,
			this.translate.getCurrentLang().slice(3)
		);
	}
}